import React from "react";
import styles from "./shift-records-filter.module.scss";
import { Field, Filter, DateRange } from "components/commons";
import { locale } from "localization/en";
import SelectCashiers from "components/field/select-cashiers/select-cashiers";
import SearchTypeField from "components/commons/search-field/search-type";

const ShiftRecordsFilter = ({
  filterState,
  modifyFilter,
  filterCount,
  applyFilter,
  applyClearFilter,
  applyClearSearch,
  resetFilter,
  searchKey,
  modifySearch,
  applySearch,
}) => {
  const searchType = [
    { label: locale.stationCode, value: "stationCode" },
    { label: locale.stationName, value: "stationName" },
    { label: locale.cashier, value: "cashier" },
    { label: locale.shiftNumber, value: "shiftNumber" },
  ];

  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <Filter
          close={resetFilter}
          clear={applyClearFilter}
          submit={() => {
            applyFilter();
          }}
          filterCount={filterCount}
        >
          <Field
            className={styles.date}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.shiftDateRange}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              onChange={(_, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({ startDate, endDate });
              }}
            />
          </Field>
          <Field
            className={styles.fieldLabel}
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale?.cashier}
          >
            <SelectCashiers
              {...filterState?.cashiers}
              isMultiple
              disableAllOption
              allSelectedText={locale.allCashiers}
              selectAllLabel={locale?.all}
              onChange={(name, { value, label, isAll }) => {
                modifyFilter({
                  cashiers: {
                    value,
                    label,
                    isAll,
                  },
                });
              }}
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchTypeField
            placeholder={locale.keyword}
            value={searchKey}
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
            searchKeyName={"searchType"}
            searchKeyValue={filterState.searchType}
            searchKeyOptions={searchType}
            searchKeyOnChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
          />
        </Field>
      </div>
    </div>
  );
};

export default ShiftRecordsFilter;
